// extracted by mini-css-extract-plugin
export default {"container":"_2G7W_","tooltip":"_3h3ty"};